import { Container, ContainerProps, CopyText, Heading } from '@dtpk-cc/components';

import './LoadingContainer.scss';

type LoadingContainerProps = ContainerProps & {
    headline?: string;
    text?: string;
};

export const LoadingContainer = ({
    headline = 'Bitte haben Sie einen Moment Geduld.',
    text = 'Sie werden weitergeleitet...',
    ...containerProps
}: LoadingContainerProps) => {
    return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Container variants={Container.Variant.centered} {...containerProps} data-test-action={'loading'}>
            {headline && <Heading variants={[Heading.Variant.brand, Heading.Variant.tertiary]}>{headline}</Heading>}
            <div className="spinnerWrapper">
                <div className="spinner" />
            </div>
            {text && <CopyText>{text}</CopyText>}
        </Container>
    );
};
